import * as S from './style';

import { RadioGroupProps } from './types';

const RadioGroup: React.FC<RadioGroupProps> = ({
  radioGroupName,
  valueInit,
  selectedValue,
  onChangeRadio,
}) => {
  return (
    <S.RadioGroupContainer
      name={radioGroupName}
      selectedValue={selectedValue}
      // eslint-disable-next-line
      onChange={({ target: { value } }: any) => onChangeRadio(value)}
    >
      <S.RadioGroupOpt data-testid="radioGroupId" value={valueInit} />
    </S.RadioGroupContainer>
  );
};

export default RadioGroup;
